




































import { Component, Prop, Vue } from "vue-property-decorator";
import { State, Getter, Action, Mutation, namespace } from "vuex-class";
const a = namespace("a");
@Component({})
export default class ResetPasswordSuccess extends Vue {
  created() {
    sessionStorage.setItem("accessLogin", "1");
  }
  goLogin() {
    this.$router.push({
      name: "Login"
    });
  }
}
